export default function AttachReportPackageReportDirective() {
  return {
    template: require('./attach-report-package-report.html'),
    scope: {
      reportPackageId: '=',
      reportId: '=',
      isReportInstance: '=',
      report: '=',
      isReportInstanceArchive: '=',
      reportArchive: '=',
    },
    controller: 'AttachReportPackageReportController',
    controllerAs: 'attachReportPackageReportVM',
    bindToController: true,
    replace: true
  };
}
